import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Transition as _Transition, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cdd9e64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dt" }
const _hoisted_2 = { class: "mb-7" }
const _hoisted_3 = {
  key: 0,
  class: "mb-15"
}
const _hoisted_4 = { class: "dt" }
const _hoisted_5 = { class: "mb-7" }
const _hoisted_6 = {
  key: 0,
  class: "flex"
}
const _hoisted_7 = { class: "dt" }
const _hoisted_8 = {
  key: "ean",
  class: "flex"
}
const _hoisted_9 = { class: "dt" }
const _hoisted_10 = { class: "mb-7" }
const _hoisted_11 = {
  key: "productDownloads",
  class: "flex"
}
const _hoisted_12 = { class: "dt" }
const _hoisted_13 = { class: "mb-7" }
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  key: "quantityMultiplier",
  class: "flex"
}
const _hoisted_19 = { class: "dt" }
const _hoisted_20 = { class: "mb-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", null, [
      _createVNode(_TransitionGroup, {
        name: "o-anim-fade-300",
        tag: "dl"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toggleCollectionCap(_ctx.variant.basketSpecifications, _ctx.specThreshold, _ctx.showMore), (spec, index) => {
            return (_openBlock(), _createElementBlock("dl", {
              key: spec.name+index,
              class: "flex"
            }, [
              _createElementVNode("dt", _hoisted_1, _toDisplayString(spec.label), 1),
              _createElementVNode("dd", _hoisted_2, _toDisplayString(spec.value), 1)
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createVNode(_Transition, { name: "o-anim-fade-300" }, {
      default: _withCtx(() => [
        (_ctx.showMore)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variant.productInformation.listItems, (item, index) => {
                return (_openBlock(), _createElementBlock("dl", {
                  key: item.name+index,
                  class: "flex"
                }, [
                  _createElementVNode("dt", _hoisted_4, _toDisplayString(item.label), 1),
                  _createElementVNode("dd", _hoisted_5, _toDisplayString(item.value), 1)
                ]))
              }), 128)),
              (_ctx.hasCollis)
                ? (_openBlock(), _createElementBlock("dl", _hoisted_6, [
                    _createElementVNode("dt", _hoisted_7, _toDisplayString(_ctx.$dictionary.get('b2c/product/measurements')), 1),
                    _createElementVNode("dd", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variant.collis, (colli) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: colli.id,
                          class: "mb-7"
                        }, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.$dictionary.get('b2c/product/parcel', [colli.number, _ctx.colliText(colli)])), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.variant.productInformation.ean)
                ? (_openBlock(), _createElementBlock("dl", _hoisted_8, [
                    _createElementVNode("dt", _hoisted_9, _toDisplayString(_ctx.$dictionary.get('b2c/product/ean')), 1),
                    _createElementVNode("dd", _hoisted_10, _toDisplayString(_ctx.variant.productInformation.ean), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasAnyDownloads)
                ? (_openBlock(), _createElementBlock("dl", _hoisted_11, [
                    _createElementVNode("dt", _hoisted_12, _toDisplayString(_ctx.$dictionary.get('b2c/product/downloads')), 1),
                    _createElementVNode("dd", _hoisted_13, [
                      (_ctx.variant.productInformation.assemblyGuideUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: "assemblyGuideUrl",
                            href: _ctx.variant.productInformation.assemblyGuideUrl,
                            target: "_blank",
                            class: "dl-link"
                          }, [
                            _createVNode(_component_c_icon, {
                              name: "icon-pdf",
                              class: "mr-10"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$dictionary.get('b2c/product/assemblyGuide')), 1)
                          ], 8, _hoisted_14))
                        : _createCommentVNode("", true),
                      (_ctx.variant.productInformation.userManualUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: "userManualUrl",
                            href: _ctx.variant.productInformation.userManualUrl,
                            target: "_blank",
                            class: "dl-link"
                          }, [
                            _createVNode(_component_c_icon, {
                              name: "icon-pdf",
                              class: "mr-10"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$dictionary.get('b2c/product/userManual')), 1)
                          ], 8, _hoisted_15))
                        : _createCommentVNode("", true),
                      (_ctx.variant.productInformation.careGuideUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: "careGuideUrl",
                            href: _ctx.variant.productInformation.careGuideUrl,
                            target: "_blank",
                            class: "dl-link"
                          }, [
                            _createVNode(_component_c_icon, {
                              name: "icon-pdf",
                              class: "mr-10"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$dictionary.get('b2c/product/careGuide')), 1)
                          ], 8, _hoisted_16))
                        : _createCommentVNode("", true),
                      (_ctx.variant.productInformation.lightingUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: "lightingUrl",
                            href: _ctx.variant.productInformation.lightingUrl,
                            target: "_blank",
                            class: "dl-link"
                          }, [
                            _createVNode(_component_c_icon, {
                              name: "icon-pdf",
                              class: "mr-10"
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$dictionary.get('b2c/product/lightning')), 1)
                          ], 8, _hoisted_17))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.showUnitInfo && _ctx.variant.quantityMultiplier > 1)
      ? (_openBlock(), _createElementBlock("dl", _hoisted_18, [
          _createElementVNode("dt", _hoisted_19, _toDisplayString(_ctx.$dictionary.get('b2c/product/note')), 1),
          _createElementVNode("dd", _hoisted_20, _toDisplayString(_ctx.$dictionary.get('b2c/product/unitsOf', [_ctx.variant.quantityMultiplier])), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.shouldDisplayShowMore)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "c-magic-line text-dusty-grey mt-10",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggleSpecifications()), ["prevent"]))
        }, _toDisplayString(_ctx.showMoreText), 1))
      : _createCommentVNode("", true)
  ]))
}